import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=b3e06d4e&scoped=true"
import script from "./Container.vue?vue&type=script&lang=ts"
export * from "./Container.vue?vue&type=script&lang=ts"
import style0 from "./Container.vue?vue&type=style&index=0&id=b3e06d4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e06d4e",
  null
  
)

export default component.exports